enum fonts {
  BODY = "Noto Sans",
  HEADER = "Open Sans"
}

export default fonts;
